module.exports = __webpack_public_path__ + "static/media/five-star-app-alt.cc78e2dc.svg";